"use client";

import Link from "next/link";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

interface TrustedByStripProps {
  className?: string;
  userCount?: number;
}

const TRUSTED_PEOPLE: Array<{
  handle: string;
  initials: string;
  image: string;
}> = [
  {
    handle: "emanueledpt",
    initials: "EP",
    image: "/images/trusted-avatar/emanuele.png",
  },
  {
    handle: "jenisearaujo",
    initials: "JA",
    image: "/images/trusted-avatar/jenise.jpg",
  },
  {
    handle: "AntonioEscudero",
    initials: "AE",
    image: "/images/trusted-avatar/antonio.jpg",
  },
  {
    handle: "mjdhameliya",
    initials: "MD",
    image: "/images/trusted-avatar/maulik.jpg",
  },
  {
    handle: "eliana_jordan",
    initials: "EJ",
    image: "/images/trusted-avatar/eliana.png",
  },
];

export function TrustedByStrip({ className = "", userCount = 800 }: TrustedByStripProps) {
  return (
    <div className={`mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 ${className}`}>
      <div className="flex items-center justify-center gap-4 sm:gap-5">
        <div className="group inline-flex -space-x-2">
          {TRUSTED_PEOPLE.map(({ handle, initials, image }, idx) => (
            <Link
              key={`trusted-${idx}`}
              href={`https://twitter.com/${handle}`}
              target="_blank"
              rel="noopener"
              aria-label={`Follow @${handle} on Twitter`}
            >
              <Avatar
                className="h-9 w-9 sm:h-11 sm:w-11 border border-border ring-2 ring-background shadow-sm transition-transform duration-200 ease-out hover:scale-105 bg-[#121212]"
                data-slot="trusted-avatar"
              >
                <AvatarImage
                  src={image}
                  alt={`@${handle}`}
                  className="object-cover"
                />
                <AvatarFallback>{initials}</AvatarFallback>
              </Avatar>
            </Link>
          ))}
        </div>
        <p className="text-sm sm:text-base text-muted-foreground">
          Trusted by{" "}
          <span className="font-medium text-foreground">
            {userCount.toLocaleString()} developers
          </span>
        </p>
      </div>
    </div>
  );
}
